module.exports = __webpack_public_path__ + "static/media/gif.c4d228fa.gif";